import {useMemo} from 'react';
import {Box, Typography} from '@mui/material';
import {ArrDrawer} from '../../../../../common/arr-drawer/ArrDrawer';
import './AanalyzerDetailsFlyout.scss';
import ArrAccordion, {
  AccordionSection,
} from '../../../../../common/arr-accordion/ArrAccordion';
import {ReactComponent as ChinaFlag} from './../../../../../../assets/images/chinaFlag.svg';
import {ReactComponent as JapanFlag} from './../../../../../../assets/images/japanFlag.svg';
import {ReactComponent as KoreaFlag} from './../../../../../../assets/images/koreaFlag.svg';
import AccordionContent from './accordion-content/AccordionContent';
import {analyzerDetailsAccordionMocks} from './mock';
import {useTranslation} from 'react-i18next';

type AnalyzerDetailsFlyoutProps = {
  isOpen: boolean;
  onClose: () => void;
};
const languages = [
  {Icon: ChinaFlag, label: 'Chinese'},
  {Icon: JapanFlag, label: 'Japanese'},
  {Icon: KoreaFlag, label: 'Korean'},
];

const AnalyzerDetailsFlyout: React.FC<AnalyzerDetailsFlyoutProps> = (props) => {
  const {isOpen, onClose} = props;
  const {t} = useTranslation();

  const renderAccordionIcons = () => (
    <Box className="accordion-language-icons">
      {languages.map(({Icon, label}, index) => (
        <Box key={label} className="accordion-language-icons__content">
          <Icon />
          <Typography
            className="typo-text body4_size"
            data-testid={`analyzer-details-flyout-lang-${index}`}
          >
            {label}
          </Typography>
        </Box>
      ))}
    </Box>
  );

  const accordionSections: AccordionSection[] = useMemo(() => {
    return analyzerDetailsAccordionMocks.map((item, index) => ({
      id: item.id,
      title: item.title,
      content: (
        <AccordionContent
          description={item.content.description}
          options={item.content.options}
          dataTestId={`${index}`}
        />
      ),
      headerRightContent: item?.title?.includes('CJK')
        ? renderAccordionIcons()
        : '',
    }));
  }, []);

  return (
    <ArrDrawer
      isOpen={isOpen}
      onClose={onClose}
      title={t('indexManagement.customIndex.selectAnalyzer.analyzerTitle')}
      side="right"
      showButton
      size="small"
      className="analyzer-details-flyout"
    >
      <Box
        className="analyzer-details-flyout__content"
        aria-label="analyzer-details-flyout-content"
      >
        <Box className="analyzer-details-flyout__content-description">
          <Typography
            tabIndex={0}
            className="typo-text body3_size description-text"
            data-testid={`analyzer-details-flyout-analyzer-description`}
          >
            {t(
              'indexManagement.customIndex.selectAnalyzer.analyzerDescription'
            )}
          </Typography>
        </Box>
        <ArrAccordion
          sections={accordionSections}
          expandedSection="1"
          isCustomSearchAccordian
          className="select-analyzer-accordion"
          dataTestId="select-analyzer-flyout"
        />
      </Box>
    </ArrDrawer>
  );
};

export default AnalyzerDetailsFlyout;
